import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';
import { FormattedMessage } from 'react-intl';

import { useAuthorUrlGenerator } from '../../hooks/useUrlGenerator';
import getRatio from '../../lib/getRatio';
import normalizeCardTheme from '../../lib/normalizeCardTheme';

import AuthorImage from '../partials/AuthorImage';
import CardTitle from '../typography/CardTitle';
import VerticalCard from './VerticalCard';

import styles from '../../styles/cards/author-vertical-card.module.css';

interface AuthorVerticalCardProps extends Partial<Author> {
    size?: CardSize | null;
    linkQuery?: Record<string, unknown> | null;
    theme?: CardTheme | LegacyCardTheme | null;
    ratio?: CardRatio | null;
    placeholder?: boolean;
    width?: number | null;
    className?: string | null;
}
function AuthorVerticalCard({
    size = null,
    slug = null,
    linkQuery = null,
    name = null,
    image = null,
    theme: providedTheme = null,
    width = 100,
    ratio = null,
    placeholder = false,
    className = null,
}: AuthorVerticalCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useAuthorUrlGenerator();
    const thumbnailRatio = getRatio(ratio, 1);
    const isMenu = theme === 'menu';
    return (
        <VerticalCard
            presentation="author-vertical"
            theme={theme || 'none'}
            size={size || 'default'}
            href={
                url(
                    {
                        slug,
                    },
                    linkQuery,
                ) || '#'
            }
            thumbnail={
                <AuthorImage
                    name={name}
                    slug={slug}
                    media={image}
                    className={styles.thumbnail}
                    width={width}
                    height={width / thumbnailRatio}
                    size="medium"
                    withoutSize
                    withPlaceholder={placeholder}
                />
            }
            thumbnailRatio={thumbnailRatio}
            className={classNames([
                styles.container,
                styles[camelCase(ratio)],
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.titleContainer}>
                <CardTitle tag="strong" className={styles.title} placeholder={placeholder}>
                    {!isMenu ? (
                        <FormattedMessage
                            defaultMessage="Découvrez les articles de {name}"
                            description="Author article"
                            values={{
                                name,
                            }}
                        />
                    ) : (
                        name
                    )}
                </CardTitle>
            </div>
        </VerticalCard>
    );
}
export default AuthorVerticalCard;
